<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-form-checkbox
                :value="true"
                v-model="data.model.recusaCadastro"
                @change="handleRecusaCadastro()"

            >
                Usuário recusou o cadastro por meio do termo de Recusa do Cadastro
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    methods: {
        handleRecusaCadastro() {
            if (this.data.model.recusaCadastro) {
                this.resetCondicao()
                this.resetSituacaoRua()
            }
        },
        resetOutraInstituicaoQuais() {

            if (!this.data.model.situacaoRua.outraInstituicao) {
                this.data.model.situacaoRua.outraInstituicaoQuais = null
            }
        },
        resetCidadao() {

            this.data.model.cidadao.profissao = null
            this.data.model.cidadao.rendaMensal = null
        },
        resetInformacaoSocioDemografia() {

            this.data.model.informacao.parentescoResponsavelId = null
            this.data.model.informacao.ocupacao = null
            this.data.model.informacao.cursoId = null
            this.data.model.informacao.frequentaEscolaCreche = false
            this.data.model.informacao.ocupacao = null
            this.data.model.informacao.situacaoMercadoTrabalhoId = null
            this.data.model.informacao.frequentaCuidadorTradicional = false
            this.data.model.informacao.participaGrupoComunitario = false
            this.data.model.informacao.acompanhamentoInfantil = []
            this.data.model.informacao.planoSaude = false
            this.data.model.informacao.comunidadeTradicional = false
            this.data.model.informacao.comunidadeTradicionalQual = null
            this.data.model.informacao.informacaoOrientacaoSexual = false
            this.data.model.informacao.orientacaoSexualId = null
            this.data.model.informacao.informacaoIdentidadeGenero = false
            this.data.model.informacao.identidadeGeneroId = null
            this.data.model.informacao.deficiente = false
            this.data.model.informacao.deficiencias = []
            this.data.model.informacao.saidaCidadaoId = null
            this.data.model.informacao.motivoSaidaData = null
        },
        resetCondicao(){

            this.data.model.condicao.gestante = false
            this.data.model.condicao.maternidadeReferencia = null
            this.data.model.condicao.pesoId = null
            this.data.model.condicao.fumante = false
            this.data.model.condicao.usaAlcool = false
            this.data.model.condicao.outrasDrogas = false
            this.data.model.condicao.hipertensao = false
            this.data.model.condicao.diabetes = false
            this.data.model.condicao.avcDerrame = false
            this.data.model.condicao.infarto = false
            this.data.model.condicao.hanseniase = false
            this.data.model.condicao.tuberculose = false
            this.data.model.condicao.cancer = false
            this.data.model.condicao.fibromialgia = false
            this.data.model.condicao.transtornoEspectroAutista = false
            this.data.model.condicao.internacao = false
            this.data.model.condicao.internacaoMotivo = null
            this.data.model.condicao.doencaCardiaca = false
            this.data.model.condicao.doencaCardiacaQuais = []
            this.data.model.condicao.problemasRins = false
            this.data.model.condicao.problemasRinsQuais = []
            this.data.model.condicao.doencaRespiratoria = false
            this.data.model.condicao.doencaRespiratoriaQuais = []
            this.data.model.condicao.tratamentoSaudeMental = false
            this.data.model.condicao.acamado = false
            this.data.model.condicao.domiciliado = false
            this.data.model.condicao.plantasMedicinais = false
            this.data.model.condicao.plantasMedicinaisQuais = null
            this.data.model.condicao.praticasIntegrativas = false
            this.data.model.condicao.outrasCondicoesPrimaria = null
            this.data.model.condicao.outrasCondicoesSecundaria = null
            this.data.model.condicao.outrasCondicoesTerciaria = null
        },
        resetSituacaoRua(){

            this.data.model.situacaoRua.situacaoRuaId = null
            this.data.model.situacaoRua.outraInstituicao = false
            this.data.model.situacaoRua.outraInstituicaoQuais = null
            this.data.model.situacaoRua.recebeBeneficio = false
            this.data.model.situacaoRua.referenciaFamiliar = false
            this.data.model.situacaoRua.visitaFamiliar = false
            this.data.model.situacaoRua.parentesco = null
            this.data.model.situacaoRua.alimentacaoDiariaId = null
            this.data.model.situacaoRua.origemAlimentacao = []
            this.data.model.situacaoRua.higienePessoal = false
            this.data.model.situacaoRua.higienePessoalQuais = []
        }
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>